import { FC, useEffect } from 'react'
import { BsStar, BsStarFill } from 'react-icons/bs'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import { useProcessContactAddress } from '../../../../../../hooks/fetch/contactAddress/useProcessContactAddress'
import useContactAddressCard from '../../../../../../hooks/useContactAddressCard'
import { useSelector } from 'react-redux'
import { selectContactFilterType } from '../../../../../../slices/contactAddressSlice'

type Props = {
  contactAddress: ContactAddressType
}

const FavoriteButton: FC<Props> = (props) => {
  const { contactAddress } = props
  const { isFavorite, setIsFavorite, iconColor } =
    useContactAddressCard(contactAddress)
  const contactFilterType = useSelector(selectContactFilterType)

  const editedContactAddressFavorite = {
    ...contactAddress,
    isFavorite: !isFavorite,
    contactName: contactAddress.contactName,
  }

  const { updateContactAddressFavorite } = useProcessContactAddress()

  //console.log(`FavoriteButton() contactAddress.contactName=${contactAddress.contactName} contactAddress.isFavorite=${contactAddress.isFavorite} isFavorite=${isFavorite}`)
  useEffect(() => {
    //console.log(`FavoriteButton().useEffect() contactAddress.contactName=${contactAddress.contactName} contactAddress.isFavorite=${contactAddress.isFavorite} isFavorite=${isFavorite} contactFilterType=${contactFilterType}`)
    if (contactFilterType === 'personal' && (isFavorite === null || isFavorite !== contactAddress.isFavorite)) {
      //console.log(`FavoriteButton().useEffect() isFavoriteを更新`)
      setIsFavorite(contactAddress.isFavorite)
    }
  }, [isFavorite, setIsFavorite, contactAddress, contactFilterType])

  return (
    <span
      className="favorite"
      onClick={(e) => {
        updateContactAddressFavorite(e, editedContactAddressFavorite)
        setIsFavorite((prev) => !prev)
      }}
    >
      {isFavorite ? (
        <BsStarFill size={'1.2rem'} color={iconColor} title="お気に入り" />
      ) : (
        <BsStar size={'1.2rem'} color={iconColor} />
      )}
    </span>
  )
}

export default FavoriteButton
